module.exports = {"casino-title":"My account","casino-1":"Phone","casino-2":"Edit my profile","casino-3":"Products","casino-4":"Current requests","casino-5":"Files","casino-6":"Leave"}


//////////////////
// WEBPACK FOOTER
// ./src/companies/casino/lang/en/user/home.lang.json
// module id = Xm/y
// module chunks = 1